// 與前版唯一不同：不在 AppContent 直接顯示 MediumPosts。
// 把 posts 與 loading 傳給 /about 的 element。

import React, { useEffect, useState } from 'react';
import './App.css';
import Reminder from './Pages/Reminder';
import Sidebar from './Components/Sidebar';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from 'react-router-dom';

import Home from './Pages/Home';
import PE from './Pages/PE';
import PS from './Pages/PS';
import PB from './Pages/PB';
import InvestingPage from './Pages/InvestingPage';
import RiskAndReward from './Pages/RiskAndReward';
import InvestmentBasics from './Pages/InvestmentBasics';
import TypesOfInvestments from './Pages/TypesOfInvestments';
import ValuationModels from './Pages/ValuationModels';
import EquityResearch from './Pages/EquityResearch';
import MAAnalysis from './Pages/MAAnalysis';
import FinanceResearch from './Pages/FinanceResearch';
import Tools from './Pages/Tools';
import About from './Pages/About'; // ← 會接收 posts/loading
import TopBar from './Components/TopBar.js';
import DCF from './Pages/DCF';
import DDM from './Pages/DDM';
import './i18n';
import LoginPage from './Pages/LoginPage';
import Breadcrumb from './Components/Breadcrumb';
import SearchPage from './Pages/SearchPage';
import RegisterPage from './Pages/register.js';
import MemberPage from './Pages/MemberPage.js';
import InvitePage from './Pages/InvitePage';
import VerifyCode from './Pages/VerifyCode.js';
import ResetPassword from './Pages/ResetPassword';
import NotFound from './Pages/NotFound';
import ClimbersDealPrivacy from './Pages/ClimbersDealPrivacy';
import ClimbersDealTerms from './Pages/ClimbersDealTerms';
import ClimbersDealSupport from './Pages/ClimbersDealSupport';
import VesselPrivacy from './Pages/VesselPrivacy';
import VesselTerms from './Pages/VesselTerms';
import VesselSupport from './Pages/VesselSupport';
import MyWork from './Pages/MyWork';
import MyWebsiteDetail from './Pages/MyWebsiteDetail';
import ClimbersDealWorkDetail from './Pages/ClimbersDealWorkDetail';
import MyUpsetTrackerDetail from './Pages/MyUpsetTrackerDetail';
import TheVesselDesign from './Pages/TheVesselDesign';
import GameIdeaDetail from './Pages/GameIdeaDetail';
import Books from './Pages/Books';
import { extractMediumPostImage } from './utils/mediumPosts';
import { Analytics } from '@vercel/analytics/react';

function AppContent() {
  const location = useLocation();
  const isLoginPage = location.pathname === '/login';
  const isHomePage = location.pathname === '/';
  const isRegisterPage = location.pathname === '/register';
  const isMemberPage = location.pathname === '/MemberPage';
  const isInvitePage = location.pathname === '/invite';
  const isVerifyCode = location.pathname === '/verifycode';
  const isResetPassword = location.pathname === '/reset-password';
  const isClimbersPrivacy = location.pathname === '/climbers-deal-privacy';
  const isClimbersTerms = location.pathname === '/climbers-deal-terms';
  const isClimbersSupport = location.pathname === '/climbers-deal-support';
  const isVesselLegal =
    location.pathname === '/vessel-privacy' ||
    location.pathname === '/vessel-terms' ||
    location.pathname === '/vessel-support';
  const isMyWorkPage = location.pathname.startsWith('/my-work');
  const isBooksPage = location.pathname.startsWith('/books');
  const isVesselDesign = location.pathname === '/thevesseldesign';

  /* ---------- 先抓 Medium RSS & 預載圖片 ---------- */
  const [posts, setPosts] = useState([]);
  const [allPosts, setAllPosts] = useState([]);
  const [loading, setLoad] = useState(true);

  useEffect(() => {
    const MEDIUM_RSS_URL = 'https://medium.com/feed/@funghokkeung';
    const cacheBuster = Math.floor(Date.now() / (10 * 60 * 1000));
    const RSS2JSON_API = `https://api.rss2json.com/v1/api.json?rss_url=${encodeURIComponent(MEDIUM_RSS_URL)}&cacheBuster=${cacheBuster}`;

    (async () => {
      try {
        const res = await fetch(RSS2JSON_API, { cache: 'no-store' });
        const json = await res.json();
        const allItems = json.items || [];
        const displayItems = allItems.slice(0, 4);

        // 預載前4個文章的圖片
        await Promise.all(
          displayItems.map((item) => {
            const url =
              extractMediumPostImage(item) || '/default-thumbnail.jpg';
            return new Promise((done) => {
              const img = new Image();
              img.src = url;
              img.onload = img.onerror = done;
            });
          })
        );

        setPosts(displayItems);
        setAllPosts(allItems); // 保存所有文章用於分頁
      } catch (e) {
        console.error('Medium feed load error', e);
      } finally {
        setLoad(false);
      }
    })();
  }, []);
  /* ----------------------------------------------- */

  return (
    <>
      {!isClimbersPrivacy &&
        !isClimbersTerms &&
        !isClimbersSupport &&
        !isVesselLegal &&
        !isMyWorkPage &&
        !isBooksPage &&
        !isVesselDesign && <TopBar />}

      {!isLoginPage &&
        !isRegisterPage &&
        !isMemberPage &&
        !isInvitePage &&
        !isVerifyCode &&
        !isResetPassword &&
        !isClimbersPrivacy &&
        !isClimbersTerms &&
        !isClimbersSupport &&
        !isVesselLegal &&
        !isMyWorkPage &&
        !isBooksPage &&
        !isVesselDesign && <Sidebar />}

      <div
        className={
          isClimbersPrivacy ||
          isClimbersTerms ||
          isClimbersSupport ||
          isVesselLegal ||
          isMyWorkPage ||
          isBooksPage ||
          isVesselDesign
            ? ''
            : 'abc'
        }
      >
        <div
          className={
            isClimbersPrivacy ||
            isClimbersTerms ||
            isClimbersSupport ||
            isVesselLegal ||
            isMyWorkPage ||
            isBooksPage ||
            isVesselDesign
              ? ''
              : `article-container ${!isHomePage ? 'non-home-page' : ''}`
          }
        >
          {!isMemberPage &&
            !isLoginPage &&
            !isRegisterPage &&
            !isInvitePage &&
            !isVerifyCode &&
            !isResetPassword &&
            !isClimbersPrivacy &&
            !isClimbersTerms &&
            !isClimbersSupport &&
            !isVesselLegal &&
            !isMyWorkPage &&
            !isBooksPage &&
            !isVesselDesign && <Breadcrumb />}

          <Routes>
            <Route path="/" element={<Home />} />
            <Route
              path="/about"
              element={
                <About posts={posts} allPosts={allPosts} loading={loading} />
              }
            />
            <Route path="/my-work" element={<MyWork />} />
            <Route path="/my-work/my-website" element={<MyWebsiteDetail />} />
            <Route
              path="/my-work/climbers-deal"
              element={<ClimbersDealWorkDetail />}
            />
            <Route
              path="/my-work/upset-tracker"
              element={<MyUpsetTrackerDetail />}
            />
            <Route path="/thevesseldesign" element={<TheVesselDesign />} />
            <Route path="/my-work/game-idea" element={<GameIdeaDetail />} />
            <Route path="/books" element={<Books />} />

            {/* 其餘 Route 原封不動 */}
            <Route path="/MemberPage" element={<MemberPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/valuation-models/pe" element={<PE />} />
            <Route path="/valuation-models/ps" element={<PS />} />
            <Route path="/valuation-models/pb" element={<PB />} />
            <Route path="/valuation-models" element={<ValuationModels />} />
            <Route path="/valuation-models/dcf" element={<DCF />} />
            <Route path="/valuation-models/ddm" element={<DDM />} />
            <Route path="/finance-research" element={<FinanceResearch />} />
            <Route path="/equity-research" element={<EquityResearch />} />
            <Route path="/ma-analysis" element={<MAAnalysis />} />
            <Route path="/tools" element={<Tools />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/verifycode" element={<VerifyCode />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              path="/investment-basics/types-of-investments"
              element={<TypesOfInvestments />}
            />
            <Route path="/investment-basics" element={<InvestmentBasics />} />
            <Route
              path="/investment-basics/risk-and-reward"
              element={<RiskAndReward />}
            />
            <Route
              path="/investment-basics/what-is-investing"
              element={<InvestingPage />}
            />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/invite" element={<InvitePage />} />
            <Route
              path="/climbers-deal-privacy"
              element={<ClimbersDealPrivacy />}
            />
            <Route
              path="/climbers-deal-terms"
              element={<ClimbersDealTerms />}
            />
            <Route
              path="/climbers-deal-support"
              element={<ClimbersDealSupport />}
            />
            <Route path="/vessel-privacy" element={<VesselPrivacy />} />
            <Route path="/vessel-terms" element={<VesselTerms />} />
            <Route path="/vessel-support" element={<VesselSupport />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </div>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
      <ConditionalReminder />
      <Analytics />
    </Router>
  );
}

// 條件性渲染 Reminder 組件
function ConditionalReminder() {
  const location = useLocation();

  // 如果在隱私政策、服務條款或支持頁面，不渲染 Reminder
  const isPrivacyOrTermsPage =
    location.pathname === '/climbers-deal-privacy' ||
    location.pathname === '/climbers-deal-terms' ||
    location.pathname === '/climbers-deal-support' ||
    location.pathname === '/vessel-privacy' ||
    location.pathname === '/vessel-terms' ||
    location.pathname === '/vessel-support' ||
    location.pathname === '/my-work' ||
    location.pathname.startsWith('/books');

  if (isPrivacyOrTermsPage) {
    return null;
  }

  return <Reminder />;
}

export default App;
